export const getTaxons = ({ config }) => config?.spreeTaxons;
export const getInternationalDietaryRestrictions = ({ config }) =>
  config?.activeProgramDetail?.preferences?.dietaryOptions || [];
export const getDefaultAskForPreferenceMessage = ({ config }) =>
  config?.defaultAskForPreferenceMessage;
export const getBundleToNonUsFeesInUsd = ({ config }) => config?.usBundleToNonUsFeesInUsd;
export const getUniversalHolidayNote = ({ config }) => config?.holidayNote;
export const getPriceTemplate = ({ config }) => config?.priceTemplates?.[0];
export const getShopTaxRate = ({ config }) => config?.shopTaxRate;
export const getDefaultShopNumber = ({ config }) => config?.defaultShopNumber;
export const getStadiumCatalogNumber = ({ config }) => config?.stadiumCatalogNumber;
export const getLockerShopFeUrl = ({ config }) => config?.lockerShopFeUrl;
